import React, {useState} from "react";
import {PageHeader} from "../../../../components/PageHeader";
import AssetDepreciationListType from "./subPages/AssetDepreciationListType";
import {toKSTISOString, toKSTISOStringEnd} from "../../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import useRequestData from "../../../../hooks/useRequestData";
import {getDepreciationList} from "../../../../api/asset/AssetDepreciationService";

function AssetDepreciationList() {
    const [checked,setChecked] = useState([]);

    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }

    const { newData, pageInfo, dataHook } = useRequestData(getDepreciationList, initDate, "depreciation");

    return (
        <>
            <div className="common-container container-height-full">
                <PageHeader header={"감가상각관리"} indicator={"자산관리 > 자산재무관리 > 감가상각관리"} />
                <AssetDepreciationListType
                    data={newData} date={initDate} pageInfo={pageInfo} dataHook={dataHook}
                    checked={{checked: checked, setChecked: setChecked}} />
            </div>
        </>
    );
}

export default AssetDepreciationList;